var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentLibraryAuthor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#bebebe;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.28,6.885H6.42V3.675h1.6L5.35,1,2.675,3.675h1.6Zm6.065.82c-.112-.12-.862-.922-1.076-1.131a.8.8,0,0,0-.557-.224h-.94l1.639,1.6h-1.9a.147.147,0,0,0-.128.071l-.437,1h-3.2l-.437-1a.148.148,0,0,0-.128-.071h-1.9l1.639-1.6H1.987a.806.806,0,0,0-.557.224C1.216,6.783.467,7.585.354,7.7c-.262.279-.405.5-.337.775l.3,1.644a.717.717,0,0,0,.67.5H9.713a.717.717,0,0,0,.67-.5l.3-1.644c.067-.274-.076-.5-.338-.775Z",
    transform: "translate(4.65 4.183)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLibraryAuthor);
export default __webpack_public_path__ + "static/media/content-library-author.39873ebc862da3fa0220143fa3d228a6.svg";
export { ForwardRef as ReactComponent };